import React from 'react';

interface SubtextWordsFoundBankProps {
  foundWords: string[];
  onOpenModal: () => void;
  longestSubWordLength?: number;
}

const capitalizeWord = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export default function SubtextWordsFoundBank({ foundWords, onOpenModal, longestSubWordLength }: SubtextWordsFoundBankProps) {
  return (
    <div className="subtext-words-found-bank" onClick={onOpenModal}>
      <div className="words-display">
        {foundWords.length > 0 ? (
          foundWords.slice().reverse().map((word, index) => {
            const isLongestWord = longestSubWordLength && word.length === longestSubWordLength;
            return (
              <span 
                key={index} 
                className={isLongestWord ? 'longest-word' : ''}
              >
                {capitalizeWord(word)}
              </span>
            );
          }).reduce((acc, element, index) => {
            // Add space between words
            return index === 0 ? [element] : [...acc, ' ', element];
          }, [] as React.ReactNode[])
        ) : (
          <span className="placeholder">Your words...</span>
        )}
      </div>
    </div>
  );
} 